/*
 * @Author: liuzijing lzjing71@163.com
 * @Date: 2021-10-14 15:39:42
 * @LastEditors: liuzijing lzjing71@163.com
 * @LastEditTime: 2023-10-20 15:21:30
 * @FilePath: \h5-new-media\src\page\madePlanV3\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const index = () => import('@/page/main.vue');
const home = () => import('../page/home.vue');
const homeOriginal = () => import('../page/homeOriginal.vue');
const homeFree = () => import('../page/homeFree.vue');
const homeBzg = () => import('../page/homeBzg.vue');
const homeNew = () => import('../page/homeNew.vue');
const enter = () => import('../page/enter.vue');
const selectInsured = () => import('../page/selectInsured.vue');
const insuredPerson = () => import('../page/insuredPerson.vue');
const familyIncome = () => import('../page/familyIncome.vue');
const contacts = () => import('../page/contacts.vue');
const servicesReservation = () => import('../page/servicesReservation.vue');
const reservationSuccess = () => import('../page/reservationSuccess.vue');
const planList = () => import('../page/planList.vue');
const planInfo = () => import('../page/planInfo.vue');
const planDetailMp = () => import('../page/planDetailMp.vue');
const oldPlanInfo = () => import('../page/oldPlanInfo.vue');
const planDetail = () => import('../page/planDetailNew.vue');
const oldPlanDetail = () => import('../page/oldPlanDetail.vue');
const planDetailToB = () => import('../page/planDetailToBNew.vue');
const vuePdf = () => import('../page/vuePdf.vue');
const vuePdfNew = () => import('../page/vuePdfNew.vue');
const vuePdfV2 = () => import('../page/vuePdfV2.vue');
const declare = () => import('@/page/userAgreement/index.vue');
const declare_byt = () => import('../page/baoyutong.vue');
const privacy = () => import('../page/privacy.vue');
const planDetailV3 = () => import('../page/planDetailV3.vue');
const personalPlanDetail = () => import('../page/personalPlanDetail.vue');
const planPDF = () => import('../page/planPDF.vue');
const planWord = () => import('../page/planPDF.vue');

const qwCard = () => import('../page/qwCard.vue');

const routes = [
  {
    path: '/madePlanV3',
    name: 'madePlan',
    component: index,
    redirect: '/madePlanV3/home',
    children: [
      {
        path: 'homeOriginal',
        name: 'homeOriginal',
        component: homeOriginal,
        meta: {
          title: '方案定制'
        }
      },
      {
        path: 'homeFree',
        name: 'homeFree',
        component: homeFree,
        meta: {
          title: '方案定制'
        }
      },
      {
        path: 'homeBzg',
        name: 'homeBzg',
        component: homeBzg,
        meta: {
          title: '方案定制'
        }
      },
      // 方案定制(前置支付)
      {
        path: 'homeNew',
        name: 'homeNew',
        component: homeNew,
        meta: {
          title: '方案定制'
        }
      },
      {
        path: 'home',
        name: 'home',
        component: home,
        meta: {
          title: '方案定制'
        }
      },
      {
        path: 'enter',
        name: 'enter',
        component: enter,
        meta: {
          title: '正在进入...'
        }
      },
      {
        path: 'selectInsured',
        name: 'selectInsured',
        component: selectInsured,
        meta: {
          title: '选择被保人'
        }
      },
      {
        path: 'insuredPerson',
        name: 'insuredPerson',
        component: insuredPerson,
        meta: {
          title: '被保人信息录入'
        }
      },
      {
        path: 'familyIncome',
        name: 'familyIncome',
        component: familyIncome,
        meta: {
          title: '投保人家庭信息录入'
        }
      },
      {
        // contacts页面删除重定向到被保人家庭信息录入页
        path: 'contacts',
        name: 'contacts',
        meta: {
          title: '联系人信息录入'
        },
        component: contacts
      },
      {
        path: 'servicesReservation',
        name: 'servicesReservation',
        component: servicesReservation,
        meta: {
          title: '预约服务'
        }
      },
      {
        path: 'reservationSuccess',
        name: 'reservationSuccess',
        component: reservationSuccess,
        meta: {
          title: '预约成功'
        }
      },
      {
        path: 'planList',
        name: 'planList',
        component: planList,
        meta: {
          title: '方案列表'
        }
      },
      {
        path: 'planInfo',
        name: 'planInfo',
        component: planInfo,
        meta: {
          title: '信息详情'
        }
      },
      {
        path: 'planDetailMp',
        name: 'planDetailMp',
        component: planDetailMp,
        meta: {
          title: '信息详情'
        }
      },
      {
        path: 'oldPlanInfo',
        name: 'oldPlanInfo',
        component: oldPlanInfo,
        meta: {
          title: '信息详情'
        }
      },
      {
        path: 'planDetail',
        name: 'planDetail',
        component: planDetail,
        meta: {
          title: '方案详情'
        }
      },
      {
        path: 'planDetailV3',
        name: 'planDetailV3',
        component: planDetailV3,
        meta: {
          title: '多保鱼家庭保障方案',
          skipLogin: true
        }
      },
      {
        path: 'oldPlanDetail',
        name: 'oldPlanDetail',
        component: oldPlanDetail,
        meta: {
          title: '方案详情'
        }
      },
      {
        path: 'declare',
        name: 'declare',
        component: declare,
        meta: {
          title: '用户协议'
        }
      },
      {
        path: 'personalPlan',
        name: 'personalPlan',
        component: personalPlanDetail,
        meta: {
          title: '多保鱼保险产品计划书',
          skipLogin: true
        }
      },
      {
        path: 'qwCard',
        name: '推送顾问',
        component: qwCard,
        meta: {
          title: '推送顾问',
        }
      }
    ]
  },
  // 不需要经过授权检查的
  {
    path: '/planDetailToB',
    name: 'planDetailToB',
    component: planDetailToB,
    meta: {
      title: '方案详情'
    }
  },
  {
    path: '/planDetailV3ToB',
    name: 'planDetailV3ToB',
    component: planDetailV3,
    meta: {
      title: '多保鱼家庭保障方案'
    }
  },
  {
    path: '/vuePdf',
    name: 'vuePdf',
    component: vuePdf,
    meta: {
      title: '预览'
    }
  },
  {
    path: '/vuePdfNew',
    name: 'vuePdfNew',
    component: vuePdfNew,
    meta: {
      title: '预览'
    }
  },
  {
    path: '/vuePdfV2',
    name: 'vuePdfV2',
    component: vuePdfV2,
    meta: {
      title: '预览'
    }
  },
  {
    path: '/declare_byt',
    name: 'declare_byt',
    component: declare_byt,
    meta: {
      title: '用户协议'
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: privacy,
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/personalPlan',
    name: 'personalPlan',
    component: personalPlanDetail,
    meta: {
      title: '多保鱼保险产品计划书'
    }
  },
  {
    path: '/planPDF',
    name: 'planPDF',
    component: planPDF,
    meta: {
      title: '多保鱼保险产品计划书PDF',
      skipLogin: true
    }
  },
  {
    path: '/planWord',
    name: 'planWord',
    component: planWord,
    meta: {
      title: '多保鱼保险产品计划书Word',
      skipLogin: true
    }
  },
  // 用来给app端跳转之后打开分享页面 ---家庭方案分享
  {
    path: '/shareFromAppPlanDetail',
    name: 'shareFromAppPlanDetail',
    component: () => import('../page/shareFromAppPlanDetail.vue'),
    meta: {
      title: '分享'
    }
  },
  // 用来给app端跳转之后打开分享页面 ---个人计划方案分享
  {
    path: '/shareFromAppPersonalPlanDetail',
    name: 'shareFromAppPersonalPlanDetail',
    component: () => import('../page/shareFromAppPersonalPlanDetail.vue'),
    meta: {
      title: '分享'
    }
  }
];

module.exports = routes;
